module.exports = __webpack_public_path__ + "static/aboutus-4-min-56895de82c42c89894888b5a832bb262.webp";